import Section from '../Section'
import classNames from 'classnames'
import { Text } from 'src/Components'
import { useSelector } from 'react-redux'
import AgentCardHeader from './AgentCardHeader'
import { QUESTIONS } from 'src/constants/messages'
import { FormattedMessage, useIntl } from 'react-intl'
import { AgentCardContactInfo } from './AgentCardContactInfo'
import { selectListingDMMetadata } from 'src/store/selectors/listings'
import { LISTINGS_DIRECT_MESSAGE_TOPIC_KEY } from 'src/constants/topicKeys'
import QuestionSingle from 'src/Components/shared/Questions/QuestionSingleContainer'
import { selectCustomerIsRealEstateAgent } from 'src/store/selectors/customerProfile'

import styles from './AgentCard.module.scss'

export interface AgentCardProps {
  className?: string
}

export const AgentCard = ({ className }: AgentCardProps) => {
  const intl = useIntl()
  const dmListingMetaData = useSelector(selectListingDMMetadata)

  const isRea = useSelector(selectCustomerIsRealEstateAgent)

  return (
    <Section className={classNames(styles.container, className)}>
      <Section.Body>
        <AgentCardHeader />
        <QuestionSingle
          metadata={dmListingMetaData}
          className={styles.question}
          placeholder={
            isRea
              ? intl.formatMessage(QUESTIONS.howIsTheNeighborhood)
              : intl.formatMessage(QUESTIONS.getListingDetailsPrequalified)
          }
          questionTopic={
            isRea
              ? intl.formatMessage(QUESTIONS.listingDetailsReaTopic)
              : intl.formatMessage(QUESTIONS.listingDetailsLoTopic)
          }
          questionTopicKey={LISTINGS_DIRECT_MESSAGE_TOPIC_KEY}
        />
        <Text
          element='div'
          className={styles.break}
          variant='neutralCool'
          variantCount='600'
          weight='semibold'
          size='s'
        >
          &mdash; <FormattedMessage id='AgentCard.or' defaultMessage='OR' />{' '}
          &mdash;
        </Text>
        <AgentCardContactInfo />
      </Section.Body>
    </Section>
  )
}
